import { render, staticRenderFns } from "./LegendLayersListStyles.vue?vue&type=template&id=0889d8de&scoped=true&"
import script from "./LegendLayersListStyles.vue?vue&type=script&lang=js&"
export * from "./LegendLayersListStyles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0889d8de",
  null
  
)

export default component.exports